
































import { Component } from 'vue-property-decorator';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';
import gsap from 'gsap';
import { Picture } from '@/components/atoms';
import { OnboardingURL } from '@/views/Onboarding/helpers';
import eventBus from '@/utils/eventBus';

@Component({
  components: { Picture }
})
export default class WelcomeTwism extends BusinessOnboardingModel {
  opacity = 0;

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get bigScreen() {
    return window.innerWidth >= 1500;
  }

  get isQAEnv() {
    return ['qa'].includes(process.env.VUE_APP_ENV || '');
  }

  get circlesPath() {
    let fileName = 'welcome-circles';

    if (this.bigScreen) {
      fileName = 'welcome-big-screen-circles';
    }

    if (this.$mobileCheck()) {
      fileName = 'mobile-circles';
    }

    return require(`@/assets/img/business-onboarding/welcome-twism/${fileName}.png`);
  }

  onComplete() {
    this.$router.replace(OnboardingURL.WELCOME_TWISM_CONNECTIONS);
  }

  enterAnimation(tl: gsap.core.Timeline) {
    tl.to(this.$refs.background, {
      duration: 2,
      scale: this.bigScreen ? 35 : 30,
      opacity: 1,
      bottom: 0,
      delay: 1
    });
    tl.to(
      [this.$refs.title, this.$refs.circles],
      {
        bottom: 0,
        top: 0,
        duration: 5,
        ease: 'elastic.inOut(1,0.9)'
      },
      '<'
    );

    tl.to(
      this.$refs.content,
      {
        duration: 0.2,
        opacity: 1
      },
      '<2'
    );
  }

  exitAnimation(tl: gsap.core.Timeline) {
    tl.to(this.$refs.content, {
      duration: 1,
      delay: 0.4,
      opacity: 0
    });
    tl.to(
      this.$refs.main,
      {
        translateY: -200,
        duration: 1
      },
      '<'
    );
  }

  mounted() {
    eventBus.$emit('disableScroll');
    if (this.isQAEnv) return;
    const tl = gsap.timeline({
      onComplete: this.onComplete
    });

    this.enterAnimation(tl);
    this.exitAnimation(tl);
    tl.play();
  }

  async created() {
    if (!this.isQAEnv) {
      this.opacity = 1;
    }

    if (!this.businessInfo) {
      await this.onCreateBusiness();
    }

    if (this.isQAEnv) {
      this.opacity = 1;
      this.finishOnboarding(false, true);
    }
  }
}
